import React, { useRef, useEffect } from 'react'

import { gsap, Power3 } from 'gsap'


import Navigation from './Navigation'
import Footer from './Footer'
import SEO from '../components/seo'

const Layout = ({ children }) => {

    let wholeContentRef = useRef(null)
    let scrollContainerRef = useRef(null)

        useEffect(() => {
        
        gsap.to(
            wholeContentRef,
            {
                duration: 1.5,
                css: {visibility: 'visible'},
                delay: 0.5,
                ease: Power3.easeOut
            }
        )
            
        gsap.from(
            scrollContainerRef,
            {
                duration:  1.5,
                y: 0,
                ease: Power3.easeOut
                }
        )
        
        }, [])
     
    return (
        <>
            <SEO title={'Cami Consulting'}/>
                <div id="home" ref={el => { wholeContentRef = el }} className="wholeContent">
                    <Navigation />
                        <div ref={el => { scrollContainerRef = el }} className="scrollContainer">
                            <main>{children}</main>
                        </div>
                    <Footer />
                </div>
        </>
    )
}

export default Layout
